import {get} from "lodash";

export function getUserFirstName(user) {
  const userName = get(user, "userDetails.data.name", "");
  if (userName) {
    return userName.split(" ")[0];
  }
}
